// import * as exports from '@components/index';

// All of the Components should be putted into Components Array
// Note: don't add the Component directly in the SharedModule
export const Components = [
//  exports.ComponentName
];
